import type { CircularProgressProps } from '@mui/material';
import { CircularProgress } from '@mui/material';
import * as React from 'react';

const CircularProgressLocal = ({ ...other }: CircularProgressProps): React.JSX.Element => {
  return <CircularProgress disableShrink {...other} />;
};

export default CircularProgressLocal;
